<script>
    import I18n from '@js/modules/translations';

    // `layer`: the selected national map when the map centre is outside its coverage, else null
    const {layer = null} = $props();

    // Where each national map has tiles, in words (modules/maps/mapCoverage.js has the boxes)
    const COVERAGE_KEY = {
        ign: 'ign',
        ign_relief: 'ign',
        swiss_topo: 'swiss_topo',
        usgs_topo: 'usgs_topo',
        os_maps: 'os_maps'
    };
</script>

<!-- Same notice as the mobile app: laid over the map without catching clicks; always present so screen
     readers announce it when it fills -->
<div class="map-coverage-notice"
     role="status">
    {#if layer}
        <div class="map-coverage-notice-card">
            <svg class="map-coverage-notice-icon"
                 xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 24 24"
                 fill="none"
                 stroke="currentColor"
                 stroke-width="1.8"
                 stroke-linecap="round"
                 stroke-linejoin="round"
                 aria-hidden="true">
                <path d="M9 4 3 6v14l6-2 6 2 6-2V4l-6 2-6-2Z"/>
                <path d="M9 4v14M15 6v14"/>
            </svg>
            <p class="map-coverage-notice-title">
                {I18n.t('js.maps.toolbar.coverage.unavailable_here', {map: I18n.t(`js.maps.toolbar.styles.${layer}`)})}
            </p>
            {#if COVERAGE_KEY[layer]}
                <p class="map-coverage-notice-text">
                    {I18n.t(`js.maps.toolbar.coverage.${COVERAGE_KEY[layer]}`)}
                </p>
            {/if}
            <p class="map-coverage-notice-text">
                {I18n.t('js.maps.toolbar.coverage.hint')}
            </p>
        </div>
    {/if}
</div>
